import StepsWalked from './stepsWalked';
import RoadMap from './roadMap';
import { BegType } from 'model/actions/city/beg';
import { RobType } from 'model/actions/city/rob';
import { WorkType } from 'model/actions/city/work';
import Admin from 'admin';
import HistoryMachine from './machine';
import Debug from 'debug';
const debug = Debug('model.party.history');

const MAX_ACTIVITIES_PER_DAY = 4;

const HistoryTypes = {
  StepsWalked: 'StepsWalked',
  FirstTown: 'FirstTown',
  BeggingBowl: 'BeggingBowl',
  MedicineWoman: 'MedicineWoman',
  TownDrunk: 'TownDrunk',
  Gun: 'Gun',
  RancherWork: 'RancherWork',
  RoadMap: 'RoadMap',
  Death: 'Death',
  Step: 'Step',
  Arrived: 'Arrived',
  Beg: BegType,
  Rob: RobType,
  Work: WorkType,
  ContinueTrip: 'CONTINUE_TRIP'
};

let onChange = () => {};
let onAction = () => {};

const History = (party, phase) => {
  const machine = HistoryMachine(party, phase);

  const stepsWalked = StepsWalked();
  const roadMap = RoadMap();

  const attribs = {
    stepsWalked: { ...stepsWalked, index: HistoryTypes.StepsWalked },
    firstTown: { value: false, index: HistoryTypes.FirstTown },
    bowl: { value: false, index: HistoryTypes.BeggingBowl },
    gun: { value: false, index: HistoryTypes.Gun },
    medicineWoman: { value: false, index: HistoryTypes.MedicineWoman },
    townDrunk: { value: false, index: HistoryTypes.TownDrunk },
    rancherWork: { value: false, index: HistoryTypes.RancherWork },
    roadMap: { ...roadMap, index: HistoryTypes.RoadMap },
    death: { value: 0, index: HistoryTypes.Death },
    step: { value: 0, index: HistoryTypes.Step },
    arrived: { value: false, index: HistoryTypes.Arrived }
  };

  const setCallbacks = (onChanged, onActions) => {
    onChange = (index, oldValue, newValue, context) => {
      onChanged.forEach(callback => callback(index, oldValue, newValue, context));
    };
    onAction = (action, total, successes, failures, context) => {
      onActions.forEach(callback => callback(action, total, successes, failures, context));
    };

    machine.updateContext({ onChange: onChange });
  };

  const init = () => {
    let { stepsWalked, step } = attribs;
    stepsWalked.value = 0;
    step.value = 0;

    // Jump to certain state
    Admin().initPhase(party, machine);
  };

  const reset = () => {
    init();
  };

  const actions = {};

  // TODO: Make this better
  const translatedAction = action => {
    switch (action) {
      case 'WALK':
      case 'ARRIVE':
      case 'TAKE_BOWL':
      case 'ENABLE_HEAL':
      case 'ENABLE_WORK':
      case 'ENABLE_ROB':
      case 'ENABLE_GOAL':
      case 'ENABLE_SHOP':
      case 'GET_HORSE':
      case 'DEPART':
        return action;
      case HistoryTypes.Death:
        return 'DIE';
      default:
        return 'UNKNOWN';
    }
  };

  const add = ({ action, day, result }, context) => {
    if (!actions[action]) actions[action] = [];
    actions[action].push(result);
    debug(action, actions[action]);

    const event = { type: translatedAction(action), result, context };
    machine.send(event);

    onAction(action, actions[action].length, successes(action), failures(action), context);
    if (!day) return;

    // Track how many actions happened today
    if (!actions[day]) actions[day] = [];
    actions[day].push({ action, result });
  };

  const delta = (resources, context) => {
    Object.keys(resources).map(res => {
      const resource = attribs[res];
      const oldValue = resource.value;
      let newValue = oldValue;
      if (typeof resources[res] == 'boolean') {
        newValue = resources[res];
      } else {
        newValue = oldValue + resources[res];
      }

      resource.value = newValue;
      debug('delta', res, resource.value, context, onChange);
      onChange(resource.index, oldValue, newValue, context);

      return newValue;
    });
  };

  const successes = action => {
    if (!actions[action]) actions[action] = [];

    return actions[action].filter(entry => entry.success).length;
  };
  const failures = action => {
    if (!actions[action]) actions[action] = [];

    return actions[action].filter(entry => !entry.success).length;
  };
  const total = action => {
    if (!actions[action]) actions[action] = [];
    return actions[action].length;
  };

  const actionsToday = day => {
    return actions[day]?.length || 0;
  };
  const remainingToday = day => {
    return MAX_ACTIVITIES_PER_DAY - actionsToday(day);
  };

  return {
    attribs,
    delta,
    add,
    total,
    successes,
    failures,
    remainingToday,
    actionsToday,
    reset,
    init,
    setCallbacks
  };
};

export { HistoryTypes };
export default History;
